export default __webpack_public_path__ + "static/media/phonedemo.dc025a59.jpeg";